import React from 'react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="py-20 px-6 bg-sage/10" data-id="element-175">
      <div className="max-w-3xl mx-auto text-center" data-id="element-176">
        <FadeIn data-id="element-177">
          <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-178">
            Lo que cambia en 7 días
          </span>
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-sage/20 relative" data-id="element-179">
            <div className="text-6xl text-sage/20 font-serif absolute top-4 left-6" data-id="element-180">
              "
            </div>
            <p className="font-serif text-xl md:text-2xl text-charcoal leading-relaxed relative z-10" data-id="element-181">
              Para el final de la primera semana, la mayoría de las mujeres
              reportan una disminución notable en la hinchazón facial, una
              digestión más ligera y, por primera vez en meses, una mañana sin
              esa sensación de pesadez interna.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}